<template>
  <v-app>
    <ayuda v-model="alerts.ayuda" />
    <profile v-model="modals.profile" />
    <v-container v-show="loading">
      <v-layout align-center justify-center row fill-height>
        <v-flex>
          <h1 id="loadingTitle" class="text-xs-center animated infinite pulse">
            {{ $t('panel.loading') }}...
          </h1>
          <v-progress-linear
            color="secondary"
            background-color="primary"
            :indeterminate="true"
          />
        </v-flex>
      </v-layout>
    </v-container>
    <v-card flat v-show="!loading">
      <v-toolbar color="white">
        <v-toolbar-side-icon @click.stop="drawer = !drawer" />
        <v-spacer />
        <router-link :to="{ name: 'Home' }">
          <img
            id="logo-home"
            max-width="170px"
            :src="require('@/assets/img/0_Skolable.png')"
          />
        </router-link>
        <v-spacer :class="!$vuetify.breakpoint.xsOnly ? 'spacerst' : ''" />

        <v-menu bottom left v-if="!$vuetify.breakpoint.xsOnly">
          <template v-slot:activator="{ on }">
            <v-btn
              class="test"
              v-on="on"
              width="110px"
              plain
              depressed
              color="white"
              :ripple="false"
              id="no-background-hover"
            >
              <v-badge v-model="flags.badge" overlap color="primary" right>
                <v-layout row wrap>
                  <v-list-tile>
                    <v-flex xs10 sm10>
                      <v-list-tile-content>
                        <v-list-tile-sub-title
                          style="font-size: 9px; color: #512e6f"
                        >
                          <strong>{{ user.branch.name }}</strong>
                        </v-list-tile-sub-title>
                      </v-list-tile-content>
                    </v-flex>
                    <v-flex xs2 sm2>
                      <template v-slot:badge>
                        <span>{{ getCountActivities }}</span>
                      </template>
                      <v-avatar size="35">
                        <img
                          v-if="getUser.img != '' && getUser.img != null"
                          :src="getUser.img"
                          alt="avatar"
                        />
                        <v-icon v-else color="#512e6f"> account_circle </v-icon>
                      </v-avatar>
                    </v-flex>
                  </v-list-tile>
                </v-layout>
              </v-badge>
            </v-btn>
          </template>
          <v-list>
            <v-list-tile avatar @click="modals.profile = true">
              <v-list-tile-avatar>
                <img
                  v-if="getUser.img != '' && getUser.img != null"
                  :src="getUser.img"
                  alt="avatar"
                />
                <v-icon v-else> account_circle </v-icon>
              </v-list-tile-avatar>
              <v-list-tile-content>
                <v-list-tile-title>{{
                  user.firstName + ' ' + user.lastName
                }}</v-list-tile-title>
                <v-list-tile-sub-title>{{
                  user.branch.name
                }}</v-list-tile-sub-title>
                <v-list-tile-sub-title>{{
                  user.webRole != null ? user.webRole.name : ''
                }}</v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile @click="qrShow()">
              <v-list-tile-action>
                <v-img
                  max-width="40px"
                  :src="require('@/assets/panel/toolbar/SKLB-QR.png')"
                  alt="activity_centre"
                ></v-img>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>{{
                  $t('panel.consultCollaboratorQR')
                }}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile
              to="activity"
              v-if="user.webRole != null && user.webRole.hierachy == 0"
            >
              <v-list-tile-action>
                <v-badge v-if="flags.badge" color="primary" right>
                  <template v-slot:badge>
                    <span>{{ getCountActivities }}</span>
                  </template>
                </v-badge>
                <v-img
                  v-else
                  max-width="40px"
                  :src="
                    require('@/assets/panel/toolbar/SKLB-Centro de actividades.png')
                  "
                  alt="activity_centre"
                />
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>{{
                  $t('panel.activityCentre')
                }}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile @click="logout">
              <v-list-tile-action>
                <v-img
                  max-width="40px"
                  :src="
                    require('@/assets/panel/toolbar/SKLB-Cerrar Sesion.png')
                  "
                  alt="activity_centre"
                />
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>{{ $t('panel.logOut') }}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile
              href="https://sites.google.com/kiritek.com/centrodeayudaskolable"
              target="_blank"
            >
              <v-list-tile-action>
                <v-img
                  max-width="40px"
                  :src="require('@/assets/panel/toolbar/SKLB-Ayudas.png')"
                  alt="activity_centre"
                />
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>{{ $t('panel.help') }}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
        </v-menu>
        <v-menu bottom left v-else>
          <template v-slot:activator="{ on }">
            <v-btn icon v-on="on">
              <v-badge v-model="flags.badge" overlap color="primary" right>
                <template v-slot:badge>
                  <span>{{ getCountActivities }}</span>
                </template>
                <v-avatar size="35" color="grey lighten-4">
                  <img
                    v-if="getUser.img != '' && getUser.img != null"
                    :src="getUser.img"
                    alt="avatar"
                  />
                  <v-icon v-else> account_circle </v-icon>
                </v-avatar>
              </v-badge>
            </v-btn>
          </template>
          <v-list>
            <v-list-tile avatar @click="modals.profile = true">
              <v-list-tile-avatar>
                <img
                  v-if="getUser.img != '' && getUser.img != null"
                  :src="getUser.img"
                  alt="avatar"
                />
                <v-icon v-else> account_circle </v-icon>
              </v-list-tile-avatar>
              <v-list-tile-content>
                <v-list-tile-title>{{
                  user.firstName + ' ' + user.lastName
                }}</v-list-tile-title>
                <v-list-tile-sub-title>{{
                  user.branch.name
                }}</v-list-tile-sub-title>
                <v-list-tile-sub-title>{{
                  user.webRole != null ? user.webRole.name : ''
                }}</v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile @click="qrShow()">
              <v-list-tile-action>
                <v-img
                  max-width="40px"
                  :src="require('@/assets/panel/toolbar/SKLB-QR.png')"
                  alt="activity_centre"
                ></v-img>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>{{
                  $t('panel.consultCollaboratorQR')
                }}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile
              to="activity"
              v-if="user.webRole != null && user.webRole.hierachy == 0"
            >
              <v-list-tile-action>
                <v-badge v-if="flags.badge" color="primary" right>
                  <template v-slot:badge>
                    <span>{{ getCountActivities }}</span>
                  </template>
                </v-badge>
                <v-img
                  v-else
                  max-width="40px"
                  :src="
                    require('@/assets/panel/toolbar/SKLB-Centro de actividades.png')
                  "
                  alt="activity_centre"
                />
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>{{
                  $t('panel.activityCentre')
                }}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile @click="logout">
              <v-list-tile-action>
                <v-img
                  max-width="40px"
                  :src="
                    require('@/assets/panel/toolbar/SKLB-Cerrar Sesion.png')
                  "
                  alt="activity_centre"
                />
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>{{ $t('panel.logOut') }}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile
              href="https://sites.google.com/kiritek.com/centrodeayudaskolable"
              target="_blank"
            >
              <v-list-tile-action>
                <v-img
                  max-width="40px"
                  :src="require('@/assets/panel/toolbar/SKLB-Ayudas.png')"
                  alt="activity_centre"
                />
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>{{ $t('panel.help') }}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
        </v-menu>
      </v-toolbar>
      <v-fade-transition mode="out-in">
        <router-view
          :nUpdateResponse="modals.dResponse"
          @flagUpdate="flags.nUpdate = true"
          @nUpdate="nextRoute"
        />
      </v-fade-transition>
    </v-card>
    <v-navigation-drawer v-model="drawer" absolute temporary>
      <v-list class="pa-1 gradiente">
        <v-list-tile avatar @click="modals.profile = true">
          <v-list-tile-avatar>
            <img
              v-if="getUser.img != '' && getUser.img != null"
              :src="getUser.img"
              alt="avatar"
            />
            <v-icon v-else> account_circle </v-icon>
          </v-list-tile-avatar>

          <v-list-tile-content>
            <v-list-tile-title class="white--text">
              {{ user.firstName + ' ' + user.lastName }}
            </v-list-tile-title>
            <v-list-tile-sub-title class="white--text">
              {{ user.webRole != null ? user.webRole.name : '' }}
            </v-list-tile-sub-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
      <v-list
        class="gradiente"
        v-if="brand.branches && brand.branches.length > 1"
      >
        <v-list-group prepend-icon="account_balance">
          <template v-slot:activator>
            <v-list-tile>
              <v-list-tile-title class="white--text">
                {{ user.branch.name }}
              </v-list-tile-title>
            </v-list-tile>
          </template>

          <v-list-tile
            v-for="(branch, i) in brand.branches.filter(
              (b) => b.id !== user.branch.id
            )"
            :key="i"
            @click="changeBranch(branch)"
          >
            <v-list-tile-action>
              <v-icon color="white"> account_balance </v-icon>
            </v-list-tile-action>
            <v-list-tile-title class="white--text" v-text="branch.name" />
          </v-list-tile>
        </v-list-group>
      </v-list>
      <v-list-tile v-else class="gradiente">
        <v-list-tile-action>
          <v-icon>account_balance</v-icon>
        </v-list-tile-action>
        <v-list-tile-title class="white--text" v-text="user.branch.name" />
      </v-list-tile>
      <v-layout class="items scroll-y scrollDesign">
        <v-list class="pt-0" dense style="width: 100%">
          <v-divider />
          <v-list-tile to="home">
            <v-list-tile-action>
              <v-icon>home</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>{{ $t('panel.home') }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile
            v-for="item in menu"
            :key="item.title"
            v-show="item.permit != 'WATCH_CART' && permits[item.permit]"
            :to="
              item.permit != 'WATCH_CART'
                ? permits[item.permit]
                  ? '/' + lang + '/panel/' + item.route
                  : null
                : null
            "
          >
            <v-list-tile-action>
              <div
                class="svg_icon"
                v-if="item.icon.includes('png') || item.icon.includes('svg')"
                :style="{
                  width: '24px',
                  height: '24px',
                  backgroundColor: '#757575',
                  mask: `url(${item.icon})`,
                  ['-webkit-mask']: `url(${item.icon})`,
                  ['-webkit-mask-repeat']: 'no-repeat',
                  ['-webkit-mask-position']: 'center',
                }"
              ></div>
              <v-icon v-else>{{ item.icon }}</v-icon>
            </v-list-tile-action>

            <v-list-tile-content :disabled="permits[item.permit]">
              <v-list-tile-title>{{ $t(item.name) }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile
            v-for="item in worshopsModules"
            :key="item.title"
            v-show="!isNormalSchool_()"
            :to="'/' + lang + '/panel/' + item.route"
          >
            <v-list-tile-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-tile-action>

            <v-list-tile-content :disabled="permits[item.permit]">
              <v-list-tile-title>{{ $t(item.name) }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile
            href="https://sites.google.com/kiritek.com/centrodeayudaskolable"
            target="_blank"
          >
            <v-list-tile-action>
              <v-icon>help_outline</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>{{
                $t('panel.helpcenter')
              }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile>
            <v-list-tile-action>
              <v-icon />
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title />
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-layout>
    </v-navigation-drawer>
    <desition
      v-model="modals.desition"
      :title="$t('panel.unsavedChangesTitle')"
      :description="$t('panel.unsavedChangesDescription')"
      @desition="desition"
    />
    <boarding
      v-model="modals.boarding"
      @logOut="logout"
      @success="verifyAdmin"
    />
    <NewBranch v-model="modals.newBranch" />
    <loading v-model="flags.loading" :text="$t('panel.changingBranch')" />
    <DisableCollege
      :value="confirmDisable.modal"
      title="Tu colegio esta suspendido"
      :description="confirmDisable.description"
      v-on:desition="confirmDisableEvent"
    />
    <QRview v-model="modals.QRcoll" :qr="qr" :qrname="qrname"></QRview>
    <!-- <PollModal
      :title="externalPoll.title"
      :description="externalPoll.description"
       v-on:desition="openPoll"
      :value="modals.poll"
    /> -->
    <v-dialog v-model="modals.poll" max-width="450" persistent>
      <v-card>
        <div class="poll__content">
          <v-icon x-large color="red" class="mx-auto">warning</v-icon>
          <h5>{{ externalPoll.title }}</h5>
          <v-card-text v-html="externalPoll.description"></v-card-text>
        </div>
        <v-card-actions class="justify-center">
          <v-btn class="btn--poll" flat="flat" @click="cancelPollModal()"
            >En otro momento</v-btn
          >
          <v-btn
            class="btn--poll accept"
            style="color: white"
            flat="flat"
            @click="openPoll()"
            >Contestar Encuesta</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import loading from '../Dialogs/Loading2'
import ayuda from './../Dialogs/Ayuda.vue'
import DisableCollege from './../Dialogs/DisableCollege.vue'
import profile from './../Modals/ProfileModal.vue'
// import PollModal from "./../Modals/PollInPanel.vue";
import { isNormalSchool } from '../../plugins/GeneralMethods'
import desition from '../Dialogs/Confirm'
import NewBranch from '../Modals/NewBranch'
import boarding from '../Modals/OnBoarding'
import QRview from '../Modals/QRViewPanel'
export default {
  components: {
    ayuda,
    profile,
    boarding,
    loading,
    NewBranch,
    desition,
    DisableCollege,
    // PollModal,
    QRview,
  },
  beforeRouteUpdate(to, from, next) {
    // if (from.name == "Levels" && this.flags.nUpdate) {
    //   this.modals.desition = true;
    //   this.route.next = next;
    // } else {
    //   next();
    // }

    next()
  },
  data: () => ({
    confirmDisable: {
      modal: false,
      description: '',
    },
    runPoll: '',
    testLocalStorage: true,
    mPoll: 1,
    drawer: null,
    loading: false,
    alerts: {
      ayuda: false,
    },
    modals: {
      profile: false,
      boarding: false,
      newBranch: false,
      desition: false,
      dResponse: false,
      poll: false,
      QRcoll: false,
    },
    qr: '',
    qrimg: '',
    qrname: '',
    user: {
      branch: {
        name: '',
      },
    },
    flags: {
      loading: false,
      badge: false,
      nUpdate: false,
    },
    brand: {},
    schoolStats: {},
    permits: [],
    lang: 'es',
    route: {
      next: null,
    },
    worshopsModules: [
      {
        nombre: 'Talleres',
        name: 'panel.workshop',
        descriptiion: 'panel.workshopDesc',
        route: 'workshop',
        activo: false,
        icon: 'home_repair_service',
        iconSelected: 'home_repair_service',
        desc: 'Visualiza, administra, descarga y crea nuevos talleres',
        iconImage: 'Workshop.png',
        permit: 'WATCH_VISITS',
      },
      {
        nombre: 'Salones',
        name: 'panel.classroom',
        descriptiion: 'panel.classroomDesc',
        route: 'classroom',
        activo: false,
        icon: 'meeting_room',
        iconSelected: 'meeting_room',
        desc: 'Visualiza, administra, descarga y crea nuevos salones ',
        iconImage: 'Classroom.png',
        permit: 'WATCH_VISITS',
      },
      {
        nombre: 'Días de asueto',
        name: 'panel.holiday',
        descriptiion: 'panel.holidayDesc',
        route: 'holidays',
        activo: false,
        icon: 'celebration',
        iconSelected: 'celebration',
        desc: 'Visualiza, administra, descarga y crea días de asueto ',
        iconImage: 'Holiday.png',
        permit: 'WATCH_VISITS',
      },
    ],
    externalPoll: {
      title: '',
      description: '',
      url: '',
      id: null,
    },
  }),
  watch: {
    getUser() {
      this.mapPermits()
    },
    getCountActivities() {
      if (this.getCountActivities > 0) {
        this.flags.badge = true
      }
    },
  },
  created() {},
  async mounted() {
    this.loading = true
    this.verifyAdmin()
    if (this.getUser && this.getUser.id) this.mapPermits()

    this.lang = this.$route.params.lang

    let localTxt = localStorage.getItem('txtPoll')
    if (localTxt) {
      this.runPoll = localTxt
    }

    if (this.runPoll === '') {
      this.getExternalPoll()
    }
  },
  methods: {
    ...mapActions(['getMsgDisableCollege', 'getBrandTZ']),

    isNormalSchool_() {
      return isNormalSchool(this.getBranch)
    },
    nameLength(a) {
      if (a.length <= 26) {
        return true
      } else {
        return false
      }
    },
    brachLength(a) {
      if (a.length <= 33) {
        return true
      } else {
        return false
      }
    },
    nextRoute() {
      this.flags.nUpdate = false
      this.modals.dResponse = false
      if (this.route.next != null) {
        this.route.next()
      }
    },
    newBranch() {
      this.modals.newBranch = true
    },
    changeBranch(branch) {
      this.flags.loading = true
      this.$store
        .dispatch('branch/changeBranch', branch.id)
        .then(() => {
          window.location.href = '/'
        })
        .catch((error) => {
          this.processErrorsChangeBrand(error)
        })
    },
    desition(event) {
      if (event) {
        this.modals.dResponse = true
      } else {
        this.route.next()
      }
    },
    mapPermits() {
      var usr = this.getUser
      var wbRol = usr.webRole
      var catalogs = wbRol.catalogs
      for (var c in catalogs) {
        if (catalogs[c].name.includes('WATCH')) {
          this.permits[catalogs[c].name] = 1
        }
      }
      this.$forceUpdate()
    },
    logout() {
      this.loading = true
      document.getElementById('loadingTitle').innerHTML = 'Cerrando Sesión'
      var v = this
      this.$forceUpdate()
      setTimeout(function () {
        v.$store
          .dispatch('login/logout')
          .then(() => {
            v.$router.push('/login')
            // localStorage.removeItem("activeBtn")
            localStorage.removeItem('txtPoll')
          })
          .catch((error) => {
            v.processErrors(error)
          })
      }, 2000)
    },
    processErrors(error) {
      if (error.response.status == 401) {
        this.$router.push('/login')
      }
    },
    processErrorsChangeBrand(error) {
      switch (error.response.status) {
        case 400:
          this.confirmDisable.description = error.response.data.entity
          this.flags.loading = false
          this.confirmDisable.modal = true
          break
      }
    },
    verifyAdmin() {
      this.$store
        .dispatch('branch/verifyAdmin')
        .then((data) => {
          this.flags.loading = false
          this.getProfile()
          console.log(data.data.entity.branch.showOnboarding)
          if (data.data.entity.branch.showOnboarding) {
            this.getBrandFromSA()
            this.modals.boarding = true
          }
        })
        .catch((error) => {
          this.flags.loading = false
          if (error.data != null && error.data.code == 404) {
            console.log('ON BOARDING...')
            this.loading = false
            this.modals.boarding = true
          } else {
            console.log(error)
          }
        })
    },
    getProfile() {
      this.$store
        .dispatch('employee/getProfile')
        .then((response) => {
          this.loading = false
          this.user = this.getUser
          let { branch } = response.data.entity
          this.getBrandTZ(branch)

          let firstName = response.data.entity.firstName
          let lastName = response.data.entity.lastName
          this.qrname = `QR_${firstName}_${lastName}`
          if (
            response.data.entity.img != '' &&
            response.data.entity.img != null
          ) {
            this.user.img = 'data:image/jpg;base64, ' + response.data.entity.img
          } else {
            this.user.img = ''
          }
          if (
            response.data.entity.qr != '' &&
            response.data.entity.qr != null
          ) {
            this.qrimg = 'data:image/jpg;base64, ' + response.data.entity.qr
          } else {
            this.qrimg = ''
          }
          this.getBrand()
        })
        .catch((error) => {
          console.log(error)
        })
    },
    getBrand() {
      this.$store.dispatch('branch/getBrand').then((response) => {
        console.log('newOB', response)
        this.brand = response.data.entity

        for (var branch in this.brand.branches) {
          if (this.brand.branches[branch].id == this.user.branch.id) {
            const imageStorageDoesExist =
              this.brand.branches[branch].imageStorage !== undefined

            this.$store.commit('updateBranch', {
              branch: {
                ...this.brand.branches[branch],
                img: imageStorageDoesExist
                  ? this.brand.branches[branch].imageStorage.miniObjUrl
                  : null,
              },
            })
          }
        }
        this.getSchoolStats()
      })
    },

    getBrandFromSA() {
      this.$store.dispatch('branch/onBoarding').then((response) => {
        console.log('newOB', response)
        this.brand = response.data
      })
    },
    getSchoolStats() {
      this.$store
        .dispatch('employee/getSchoolStats', this.getBranch.id)
        .then((response) => {
          this.schoolStats = response.data.entity
          this.checkConfiguration()
        })
        .catch((error) => {
          console.log(error)
        })
    },
    checkConfiguration() {
      this.$store.dispatch('employee/checkConfiguration')
    },
    qrShow() {
      this.qr = ''
      if (this.qrimg != '') {
        this.qr = this.qrimg
        this.modals.QRcoll = true
      }
    },
    openPoll() {
      this.$store
        .dispatch('polls/externalPollAnswer', this.externalPoll.id)
        .then((response) => {
          window.open(this.externalPoll.url, 'blank')
          this.cancelPollModal()
        })
        .catch((e) => {
          console.log(e)
        })
    },

    getExternalPoll() {
      this.$store
        .dispatch('polls/externalPoll')
        .then((response) => {
          console.log(response.data)
          this.externalPoll.title = response.data.title
          this.externalPoll.description = response.data.description
          this.externalPoll.url = response.data.url
          this.externalPoll.id = response.data.id
          console.log(response.status)
          this.modals.poll = true
        })
        .catch((error) => {
          console.log(error)
          this.processErrorsExternalPoll(error)
        })
    },
    processErrorsExternalPoll(error) {
      if (error.response.status == 404) {
        this.cancelPollModal()
      }
    },
    resetPoll() {
      this.externalPoll.title = ''
      this.externalPoll.description = ''
      this.externalPoll.url = ''
      this.externalPoll.id = null
    },
    cancelPollModal() {
      this.modals.poll = false
      this.runPoll = 'CLOSER'
      localStorage.setItem('txtPoll', this.runPoll)
    },
    confirmDisableEvent(confirm) {
      if (confirm) {
        window.location.href = '/'
        this.confirmDisable.modal = false
      }
      window.location.href = '/'
      this.confirmDisable.modal = false
    },
  },
  computed: {
    menu() {
      return this.$store.getters.getMenuItems
    },

    //Mappers
    ...mapGetters(['getUser', 'getBranch', 'getCountActivities']),
  },
}
</script>

<style>
#logo-home {
  width: auto;
  max-width: 170px;
  height: auto;
}

.card--flex-toolbar {
  margin-top: -64px;
}
.items {
  overflow: auto;
  max-height: calc(100vh - 112px);
}
.expandableContainer {
  border-style: solid !important;
  border-color: #e6e6e6 !important;
  border-radius: 15px !important;
  border-width: 2px !important;
}
.spacerst {
  margin-right: -140px;
}
</style>
<style scoped>
::v-deep .v-list__tile--active div .svg_icon {
  background-color: #ef565c !important;
}
/deep/ .v-datatable.v-table > thead {
  display: block;
}

/deep/ .v-datatable.v-table > tbody {
  max-height: 40vh;
  min-height: 40vh;
  overflow-y: auto;
  overflow-x: hidden;
  display: block;
  -webkit-overflow-scrolling: touch;
  scrollbar-color: rgba(239, 86, 91, 1) !important;
  scrollbar-color: -moz-linear-gradient(
    left,
    rgba(239, 86, 91, 1) 0%,
    rgba(81, 46, 111, 1) 100%
  ) !important;
  scrollbar-color: -webkit-gradient(
    left top,
    right top,
    color-stop(0%, rgba(239, 86, 91, 1)),
    color-stop(100%, rgba(81, 46, 111, 1))
  ) !important;
  scrollbar-color: -webkit-linear-gradient(
    left,
    rgba(239, 86, 91, 1) 0%,
    rgba(81, 46, 111, 1) 100%
  ) !important;
  scrollbar-color: -o-linear-gradient(
    left,
    rgba(239, 86, 91, 1) 0%,
    rgba(81, 46, 111, 1) 100%
  ) !important;
  scrollbar-color: -ms-linear-gradient(
    left,
    rgba(239, 86, 91, 1) 0%,
    rgba(81, 46, 111, 1) 100%
  ) !important;
  scrollbar-color: linear-gradient(
    to right,
    rgba(239, 86, 91, 1) 0%,
    rgba(81, 46, 111, 1) 100%
  ) !important;
  scrollbar-width: thin;
}
/deep/ .test .v-btn__content {
  width: 150px;
}
/deep/ #no-background-hover::before {
  background-color: transparent !important;
}
.title {
  text-align: center;
}
h5 {
  font-size: 17px;
}
.poll__content {
  width: 100%;
  text-align: center;
  padding: 10px 0px 0px 0px;
}
.btn--poll {
  border-radius: 10px;
  border: 1px solid #c1c3c6;
}
.accept {
  color: white;
  background: #f06b71;
}
</style>

<style lang="sass">
@import url("https://cdnjs.cloudflare.com/ajax/libs/animate.css/3.7.0/animate.min.css")
</style>
